import { Modal, message } from "antd";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { tabsTypes, monitoringTabs, supplyChainTabs } from "./conig";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Monitoring from "./components/monitoring";
import SupplyChain from "./components/supply-chain";
import { ProjectService } from "../../../../services";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../store/reducers/project";
import { actions as authActions } from "../../../../store/reducers/authentication";
import { getSourceName } from "../../../../helpers/user";

export const Style = styled.div`
  position: relative;

  .flex-c {
    display: flex;
    flex-direction: column;
  }

  .flex-r {
    display: flex;
  }

  .jus-c {
    justify-content: center;
  }

  .flex-1 {
    flex: 1;
  }

  .row-item {
    .tooltip-icon {
      color: var(--base-gray-60);
    }

    .label {
      color: var(--base-gray-90);
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 0px;
    }

    .value {
      color: #101828;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0px;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: var(--size-lg);
  }
`;

export default function ProjectVisualisation({
  settingsVisible = false,
  setSettingsVisible = () => { },
  projectData = {},
  setReset = () => { },
  activeTab = tabsTypes.MONITORING,
  setDefaultSources = () => { },
  focusParticipant,
}) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authentication);
  const { projects } = useSelector((state) => state.project.data);
  const { sources: projectSources } = useSelector((state) => state.project);
  const [activeKey, setActiveKey] = useState(
    activeTab === tabsTypes.MONITORING ? monitoringTabs[0].key : supplyChainTabs[0].key
  );
  const [formValue, setFormValue] = useState({ country: projectData.country });
  const [showSupplyChain, setShowSupplyChain] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [sources, setSources] = useState();
  const [disabledFooter, setDisabledFooter] = useState(false);

  const onChange = (key, value) =>
    setFormValue((prev) => ({ ...prev, [key]: value }));

  useEffect(() => {
  }, [projectData]);

  const tabsConfig = useMemo(() =>
    activeTab === tabsTypes.MONITORING ? monitoringTabs : supplyChainTabs
    , [activeTab]);

  useEffect(() => {
    const _activeKey = activeTab === tabsTypes.MONITORING ? monitoringTabs[0].key : supplyChainTabs[0].key;

    if (activeKey !== _activeKey) {
      setActiveKey(_activeKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  const _fetch = async (_user = {}, mappedSources) => {
    const settings = (user?.settings?.projects || []).find((s) => s.id === projectData?.id)
    const _mappedSources =
      mappedSources || (_user?.sources || []).filter((it) => it.status === 'approved').map((it) => it.authorId);
    setDefaultSources(_mappedSources?.length || 0);

    if (settings && settings.visualisation) {
      const _data = settings.visualisation;

      if (!_data.monitoringInformationSources) {
        _data.monitoringInformationSources = _mappedSources;
      }

      if (!_data.supplyChainInformationSources) {
        _data.supplyChainInformationSources = _mappedSources;
      }

      setFormValue(settings.visualisation);
    } else {
      setFormValue({
        country: projectData.country,
        monitoringInformationSources: _mappedSources,
        supplyChainInformationSources: _mappedSources,
      });
    }
  };

  useEffect(() => {
    const authorId = user.company.id;
    const _user = (projectData?.participant || []).find((p) => p.authorId === authorId);

    const participants = projectSources;

    const _data = participants.map((p) => {
      const _client = (projectData?.clients || []).find((c) => c.authorId === p.authorId);
      const _source = (projectData?.sources || []).find((c) => c.authorId === p.authorId);
      const shared = _source ? _source.shareInfo : _client ? _client.shareInfo : [];
      const isOwnData = p.authorId === authorId;

      if (!_client && !_source) {
        let user;

        participants.forEach((_p) => {
          if (user) {
            return;
          }

          (_p.clients || []).forEach((c) => {
            if (user) {
              return;
            }
            if (c.authorId === p.authorId) {
              user = {
                ...p,
                id: p.authorId,
                shared: c.shareInfo || [],
                sourceName: p?.user?.organisationName || [],
                isOwnData,
              }
              return;
            }
          });
          (_p.sources || []).forEach((c) => {
            if (user) {
              return;
            }
            if (c.authorId === p.authorId) {
              user = {
                ...p,
                id: p.authorId,
                shared: c.shareInfo || [],
                sourceName: p?.user?.organisationName || [],
                isOwnData,
              }
            }
          });
        });

        if (user) {
          return user;
        }
      }

      return {
        ...p,
        id: p.authorId,
        shared: !isOwnData ? shared : projectData?.shareInfo,
        sourceName: getSourceName(p),
        isOwnData,
      }
    });

    setSources(_data);
    _fetch(_user, _data.map((d) => d.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectData, projectSources]);

  const onClose = () => {
    setSettingsVisible(false);
    _fetch();
  }

  const onSubmit = async () => {
    try {
      setLoading(true);
      await ProjectService.submitSettings(localStorage.getItem('project'), formValue);
      const _newProjects = projects.map((p) => {
        if (p.id === projectData.id) {
          return {
            ...p,
            participant: p.participant.map((_p) => {
              if (_p.authorId === user.company.id) {
                return {
                  ..._p,
                  settings: {
                    ..._p.settings,
                    visualisation: formValue
                  },
                }
              }
              return _p;
            })
          }
        }
        return p;
      })

      const _newSettings = (user?.settings) ? !(user?.settings?.projects || []).find((s) => s.id === projectData.id) ?
        [
          ...(user?.settings?.projects || []),
          {
            id: projectData.id,
            visualisation: formValue,
          },
        ]
        : (user?.settings?.projects || []).map((s) => {
          if (s.id === projectData.id) {
            return {
              ...s,
              visualisation: formValue,
            }
          }
          return s;
        }) : [
        {
          id: projectData.id,
          visualisation: formValue,
        },
      ];

      dispatch(actions.UpdateProjects(_newProjects))
      dispatch(authActions.UpdateSettings({ projects: _newSettings }))
      setReset(true);
      setLoading(false);
      setSettingsVisible(false);
    } catch (err) {
      setLoading(false);
      message.error(err?.message || t('Error occurred'));
    }
  }

  const onChangeSelect = (val) => {
    if (val === tabsTypes.SUPPLY_CHAIN && !showSupplyChain) {
      setShowSupplyChain(true);
    }

    setActiveKey(val);
  };

  const disabledFooterText = useMemo(() => {
    if (formValue.typeOfArea === 'customArea' && !formValue.area) {
      return 'Please draw area';
    }
  }, [formValue]);

  return (
    <Modal
      open={settingsVisible}
      onCancel={() => setSettingsVisible(false)}
      footer={null}
      title={(
        <Header
          t={t}
          activeKey={activeKey}
          setActiveKey={onChangeSelect}
          tabsConfig={tabsConfig}
        />
      )}
      width={630}
      className="custom-modal"
    >
      <Style>
        <div style={{ display: activeTab === tabsTypes.MONITORING ? 'block' : 'none' }}>
          <Monitoring
            formValue={formValue}
            t={t}
            onChange={onChange}
            activeKey={activeKey}
            sources={sources}
          />
        </div>
        <div style={{ display: activeTab === tabsTypes.SUPPLY_CHAIN ? 'block' : 'none' }}>
          <SupplyChain
            setDisabledFooter={setDisabledFooter}
            formValue={formValue}
            t={t}
            onChange={onChange}
            sources={sources}
            activeKey={activeKey}
            id={projectData?.id}
            focusParticipant={focusParticipant}
          />
        </div>
        <Footer
          onClose={onClose}
          onSubmit={onSubmit}
          loading={loading}
          t={t}
          disabledFooterText={disabledFooterText}
          disabledFooter={disabledFooter}
        />
      </Style>

    </Modal>
  )
}
